import React, { useState, useEffect } from "react";
import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  useTheme,
  IconButton,
  styled,
  Stack,
  Checkbox,
  FormControlLabel,
  Button,
  Divider,
  Box,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const globalUrl =
  process.env.NODE_ENV !== "production"
    ? "http://localhost:5000"
    : window.location.origin;

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    backgroundColor: "rgb(255,255,255)",
    borderRadius: "1rem",
    border: "1px solid lightgrey",
  },
}));

const ModalPersetujuanDownload = ({ open, onClose, dataDetail }) => {
  useTheme();

  const [agree, setAgree] = useState(false);

  // Reset checkbox tiap modal dibuka/tutup
  useEffect(() => {
    if (!open) setAgree(false);
  }, [open]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = globalUrl + "/" + dataDetail?.path + "?app=colagio";
    link.download = dataDetail?.title ? `${dataDetail.title}.pdf` : true;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    onClose();
  };

  return (
    <CustomDialog open={open} maxWidth="md" fullWidth>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems="center"
      >
        <DialogTitle>
          <b>Pernyataan Persetujuan Kandidat Terkait Offering Letter</b>
        </DialogTitle>
        <IconButton sx={{ mr: "1rem" }} onClick={onClose}>
          <Close />
        </IconButton>
      </Stack>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2">
            Mohon membaca seluruh informasi berikut sebelum mengunduh Offering
            Letter. Dengan mengklik tombol <b>&quot;Saya Setuju&quot;</b>, saya
            menyatakan bahwa:
          </Typography>

          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              1. Kerahasiaan Dokumen (Confidentiality)
            </Typography>
            <Typography variant="body2" paragraph>
              Saya memahami bahwa Offering Letter merupakan dokumen yang
              bersifat rahasia dan hanya ditujukan kepada saya sebagai kandidat.
              Saya bersedia untuk:
            </Typography>
            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              <Typography component="li" variant="body2">
                Tidak menyebarluaskan, mengunggah, ataupun membagikan sebagian
                maupun seluruh isi Offering Letter kepada pihak mana pun tanpa
                persetujuan PT Pamapersada Nusantara;
              </Typography>
              <Typography component="li" variant="body2">
                Menggunakan dokumen ini hanya untuk keperluan proses rekrutmen.
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              2. Pemahaman Isi Dokumen
            </Typography>
            <Typography variant="body2">
              Saya memahami bahwa saya wajib membaca seluruh isi Offering Letter
              secara lengkap sebelum memberikan keputusan. Apabila terdapat
              informasi yang belum dipahami, saya akan menghubungi PIC
              Recruitment sebelum menandatangani dokumen.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              3. Batas Waktu Persetujuan
            </Typography>
            <Typography variant="body2" paragraph>
              Saya memahami bahwa Offering Letter wajib saya tandatangani paling
              lambat 3 (tiga) hari kalender sejak tanggal diterima melalui
              sistem. Apabila sampai batas waktu tersebut saya belum memberikan
              persetujuan ataupun konfirmasi kepada PIC Recruitment, maka
              perusahaan berhak:
            </Typography>
            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              <Typography component="li" variant="body2">
                Membatalkan Offering Letter; dan/atau
              </Typography>
              <Typography component="li" variant="body2">
                Mengalihkan kesempatan tersebut kepada kandidat lainnya.
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              4. Perlindungan Data Pribadi
            </Typography>
            <Typography variant="body2">
              Saya memahami bahwa data pribadi yang saya berikan selama proses
              rekrutmen akan digunakan sesuai kebutuhan proses administrasi
              ketenagakerjaan dan dikelola sesuai ketentuan peraturan
              perundang-undangan yang berlaku mengenai perlindungan data
              pribadi.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              5. Keaslian dan Keabsahan Dokumen
            </Typography>
            <Typography variant="body2">
              Saya memahami bahwa Offering Letter yang saya unduh merupakan
              dokumen resmi perusahaan. Saya tidak diperkenankan mengubah,
              memodifikasi, ataupun memalsukan isi dokumen tersebut dalam bentuk
              apa pun.
            </Typography>
          </Box>

          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              6. Keputusan Kandidat
            </Typography>
            <Typography variant="body2" paragraph>
              Saya memahami bahwa:
            </Typography>
            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              <Typography component="li" variant="body2">
                Penandatanganan Offering Letter merupakan bentuk persetujuan
                awal terhadap penawaran kerja yang diberikan;
              </Typography>
              <Typography component="li" variant="body2">
                Proses administrasi berikutnya tetap harus dipenuhi sesuai
                ketentuan perusahaan (misalnya pemberkasan, penandatanganan
                PKWT/PKWTT, onboarding, dan persyaratan lainnya apabila
                berlaku).
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
              7. Persetujuan Elektronik
            </Typography>
            <Typography variant="body2">
              Saya menyatakan bahwa persetujuan yang saya berikan melalui sistem
              ini memiliki kekuatan yang sama dengan persetujuan tertulis sesuai
              ketentuan yang berlaku.
            </Typography>
          </Box>

          <Divider />

          <FormControlLabel
            control={
              <Checkbox
                checked={agree}
                onChange={(e) => setAgree(e.target.checked)}
              />
            }
            label={
              <Typography variant="body2">
                Saya telah membaca, memahami, dan menyetujui seluruh ketentuan
                di atas.
              </Typography>
            }
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Kembali
        </Button>
        <Button variant="contained" onClick={handleDownload} disabled={!agree}>
          Saya Setuju & Download Offering Letter
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default ModalPersetujuanDownload;
